module.exports = __webpack_public_path__ + "static/39FEA2_B_0-f88a725b257a492ffe8a92d71dce9a3f.woff2";